import React, { useState } from 'react';
import ProfileCtaModal from '../../profile-cta-modal';

export const useProfileCtaModal = ({
  profile,
  bookingLinkTarget,
  directBookHref,
  isVirtualCare,
  log,
  config
}) => {
  const [profileCtaModalIsOpen, setProfileCtaModalIsOpen] = useState(false);
  const profileCtaModal = profile ? (
    <ProfileCtaModal
      isOpen={profileCtaModalIsOpen}
      onClose={() => setProfileCtaModalIsOpen(false)}
      provider={profile?.provider}
      bookingLinkTarget={bookingLinkTarget}
      directBookHref={directBookHref}
      isVirtualCare={isVirtualCare}
      log={log}
      config={config}
    />
  ) : null;

  return { profileCtaModal, setProfileCtaModalIsOpen };
};
